import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7a56f5ec&"
import script from "./App.vue.ts?vue&type=script&lang=ts&"
export * from "./App.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports